/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchPoolsDictionaryResponse } from './search-pools-dictionary-response';


export interface SearchPoolsDictionaryResponsePagedList { 
    totalCount?: number;
    items?: Array<SearchPoolsDictionaryResponse> | null;
}

